// FILE: src/data/index.js
const DATA = {
    company: {
      name: "TekiMart",
      tagline: "We make IT possible.",
      blurb:
        "A senior-led product engineering studio crafting dependable, elegant web and mobile software. From idea to launch to iteration, we ship with care and speed.",
      email: "hello@tekimart.com",
      // phone: "+1 (555) 555-0199",
      sinceYear: 2015,
      ctaCalendar: "", // e.g., "https://cal.com/tekimart/intro"
      location: "Remote • Canada",
      logoHex: "#368cff",
    },
    nav: [
      { id: "home", label: "Home" },
      { id: "services", label: "Services" },
      { id: "work", label: "Work" },
      { id: "approach", label: "Approach" },
      { id: "tech", label: "Tech" },
      { id: "about", label: "About" },
      { id: "contact", label: "Contact" },
    ],
    services: [
      { title: "Product & UX", desc: "Discovery, user journeys, wireframes, design systems, and rapid prototypes.", icon: "compass" },
      { title: "Web Apps", desc: "Modern frontends, robust APIs, real-time features, and clean architecture.", icon: "window" },
      { title: "Mobile", desc: "React Native apps for iOS/Android with shared code and native integrations.", icon: "phone" },
      { title: "Data & Search", desc: "PostgreSQL, analytics pipelines, OpenSearch, and in-app search experiences.", icon: "db" },
      { title: "DevOps & Scale", desc: "CI/CD, observability, cost/perf tuning, and zero-downtime migrations.", icon: "cloud" },
      { title: "Team Augmentation", desc: "Principal-level engineers who embed to accelerate your roadmap.", icon: "team" },
    ],
    work: [
      // { title: "Official.lk", tags: ["Web Platform", "CMS"], desc: "Create event microsites in minutes and manage online presence with ease.", link: "https://official.lk" },
      // { title: "eVoteMe.lk", tags: ["Polling", "Scalability"], desc: "A secure online polling platform for modern, high-engagement campaigns.", link: "https://evoteme.lk" },
      { title: "Play-Pal.online", tags: ["React", "Product Delivery"], desc: "Engineering partner on a playful social experience for groups.", link: "https://play-pal.online" },
      { title: "PocketPenny.online", tags: ["React", "Data Viz", "Firebase"], desc: "Personal finance SaaS with ingestion, rules engine, and actionable insights.", link: "https://pocketpenny.online" },
      { title: "DrobeSense", tags: ["React", "AI Assist"], desc: "Smart outfit planning aligned to weather, calendar, and personal style.", link: "https://drobesense.tekimart.com" },
    ],
    approach: [
      { title: "Align on outcomes", desc: "We define success, constraints, and KPIs before code." },
      { title: "Ship thin slices", desc: "Small, testable increments reduce risk and prove value." },
      { title: "Design in the open", desc: "Clickable prototypes and regular reviews keep us aligned." },
      { title: "Automate quality", desc: "CI, preview envs, and guardrails from day one." },
      { title: "Own the results", desc: "Post-launch iteration tied to real product metrics." },
    ],
    tech: [
      { name: "React", kind: "Frontend" },
      { name: "React Native", kind: "Mobile" },
      { name: "Node.js", kind: "Backend" },
      { name: "Ruby on Rails", kind: "Backend" },
      { name: "PostgreSQL", kind: "Data" },
      { name: "OpenSearch", kind: "Search" },
      { name: "Firebase", kind: "Auth/RTDB" },
      { name: "AWS", kind: "Cloud" },
      { name: "Docker", kind: "Infra" },
      { name: "Vite/CRA", kind: "Tooling" },
    ],
    timeline: [
      { year: 2015, text: "Founded in Sri Lanka; top-10 tech startup recognition the same year." },
      { year: 2018, text: "Expanded delivery across web and mobile for local & APAC clients." },
      // { year: 2020, text: "Scaled data stacks, search, and DevEx for high-growth teams." },
      { year: 2020, text: "Relocated operations to Canada to serve global customers." },
      { year: new Date().getFullYear(), text: "Ready to partner on your next build." },
    ],
    testimonials: [
      { quote: "Clear decisions, clean architecture, and on-time delivery. They operate like an elite internal team.", author: "Director of Engineering", company: "Growth SaaS" },
      { quote: "We launched fast and confidently—senior craft all the way through.", author: "Founder", company: "Consumer App" },
    ],
    clients: ["NSBM", "CA Sri Lanka", "Chocolaate Magazine", "Siri Wijayaramaya (CSR)"],
    socials: [
      { label: "GitHub", href: "https://github.com/tekimart" },
      { label: "LinkedIn", href: "https://www.linkedin.com/company/tekimart" },
      { label: "X / Twitter", href: "https://twitter.com/tekimart" },
    ],
  };
  
  export default DATA;
  